import { Page } from "@/pages/explorer/types";
import { StreamlitNotebookChildQueriesListResponse } from "@/pages/query/types";
import { useAppState } from "@/modules/app/useAppContext";
import { formatBytes, formatCost, formatMilliseconds } from "@/helpers/utils";
import dayjs from "dayjs";
import { Stack } from "@altimateai/lego";
import { DataTable } from "@/components/tables";
import { Paginate } from "@/components/paginate";

export const CommonTaskHistoryTable = ({
  tableData,
  page,
  pageSize,
  setPage,
  updatePageSize,
}: {
  tableData: Page<StreamlitNotebookChildQueriesListResponse>;
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  updatePageSize: (size: number) => void;
}) => {
  const { currency } = useAppState();

  const tableHeaders = [
    {
      id: 1,
      label: "Task ID",
      uid: "task_id",
      render: (item: StreamlitNotebookChildQueriesListResponse) => (
        <div className="al-text-brand condense-text cursor-pointer">
          {item.query_summary}
        </div>
      ),
    },
    {
      id: 2,
      label: "Query Cost",
      uid: "query_cost",
      render: (item: StreamlitNotebookChildQueriesListResponse) => (
        <div>{formatCost(item.cost, currency)}</div>
      ),
    },
    {
      id: 3,
      label: "Bytes Scanned",
      uid: "bytes_scanned",
      render: (item: StreamlitNotebookChildQueriesListResponse) => (
        <div>{formatBytes(item.bytes_scanned)}</div>
      ),
    },
    {
      id: 4,
      label: "Execution Time",
      uid: "execution_time",
      render: (item: StreamlitNotebookChildQueriesListResponse) => (
        <div>{formatMilliseconds(item.execution_time)}</div>
      ),
    },
    {
      id: 5,
      label: "Warehouse",
      uid: "warehouse",
      render: (item: StreamlitNotebookChildQueriesListResponse) => <div>{item.warehouse_name}</div>,
    },
    {
      id: 6,
      label: "Timestamp",
      uid: "start_time",
      render: (item: StreamlitNotebookChildQueriesListResponse) => (
        <div>{dayjs(item.start_time).format("YYYY-MM-DD hh:mm a")}</div>
      ),
    },
    {
      id: 7,
      label: "Status",
      uid: "execution_status",
      render: (item: StreamlitNotebookChildQueriesListResponse) => (
        <span>{item.execution_status}</span>
      ),
    },
  ];

  return (
    <Stack direction={"column"} gap={"lg"}>
      <DataTable
        header={tableHeaders}
        data={tableData}
        idKey={(item: StreamlitNotebookChildQueriesListResponse) => item.session_id}
      />
      <Paginate
        itemCount={tableData?.total || 0}
        numPages={tableData?.pages || 0}
        page={page}
        pageSize={pageSize}
        onPageClick={setPage}
        onPageSizeChange={updatePageSize}
        showPageSize
      />
    </Stack>
  );
};
